const EDIT_PAYMENT_METHOD = 'CARD',
HALF_DIVIDER= 2;

export { EDIT_PAYMENT_METHOD, HALF_DIVIDER };
